<template>
  <div
    class="bg-white dark:bg-dark-surface rounded-3xl border border-slate-100 dark:border-white/5 shadow-xl transition-colors"
  >
    <!-- Header -->
    <div
      class="p-6 border-b dark:border-white/5 flex justify-between items-center bg-slate-50/50 dark:bg-white/5"
    >
      <h3 class="text-sm font-black uppercase tracking-widest text-primary">
        {{ $t("recent_messages") }}
      </h3>
      <BaseButton
        type="secondary"
        size="sm"
        class="!rounded-xl !py-1 text-[10px] uppercase font-black tracking-widest"
        @click="$router.push('/admin/chats')"
      >
        {{ $t("view_all") }}
      </BaseButton>
    </div>

    <!-- Error State -->
    <div v-if="error" class="p-6 text-center text-red-500">
      <p class="text-xs font-bold uppercase tracking-widest">{{ error }}</p>
    </div>

    <div v-else class="p-2">
      <!-- Skeleton Loading State -->
      <div v-if="loading" class="space-y-2 p-2 animate-pulse">
        <div
          v-for="i in 3"
          :key="`chat-skeleton-${i}`"
          class="flex items-center gap-4 p-3"
        >
          <div
            class="w-10 h-10 rounded-xl bg-slate-200 dark:bg-dark-input/50"
          ></div>
          <div class="flex-1 space-y-2">
            <div class="flex justify-between items-center">
              <div
                class="h-2.5 bg-slate-200 dark:bg-dark-input rounded w-16"
              ></div>
              <div
                class="h-2 bg-slate-200 dark:bg-dark-input rounded w-8"
              ></div>
            </div>
            <div class="h-2 bg-slate-200 dark:bg-dark-input rounded w-32"></div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div
        v-else-if="!chats || chats.length === 0"
        class="p-12 text-center text-slate-400"
      >
        <i
          class="fas fa-comments text-3xl mb-3 block text-slate-300 dark:text-slate-600"
        ></i>
        <p class="text-[10px] font-black uppercase tracking-widest">
          {{ $t("no_new_messages") }}
        </p>
      </div>

      <!-- Data List State -->
      <div v-else class="space-y-1">
        <div
          v-for="chat in chats"
          :key="chat.id"
          @click="$router.push({ name: 'ChatRoom', params: { id: chat.id } })"
          class="flex items-center gap-4 p-4 rounded-2xl hover:bg-slate-50 dark:hover:bg-white/5 cursor-pointer transition-all group"
        >
          <div
            class="w-10 h-10 rounded-xl bg-slate-100 dark:bg-dark-input flex items-center justify-center text-sm font-black text-primary shadow-inner"
          >
            {{ getChatSenderLetter(chat) }}
          </div>

          <div class="flex-1 min-w-0">
            <div class="flex justify-between items-start">
              <h4
                class="text-xs font-black text-slate-800 dark:text-white truncate uppercase tracking-tighter"
              >
                {{ chat.renter?.username || $t("user") }}
              </h4>
              <span
                class="text-[8px] font-black text-slate-400 uppercase tracking-tighter"
              >
                {{ formatChatTime(chat.last_message_at) }}
              </span>
            </div>
            <p
              class="text-[10px] text-slate-500 dark:text-slate-400 truncate font-bold mt-0.5"
            >
              {{ chat.last_message || $t("no_messages_yet") }}
            </p>
          </div>

          <div
            v-if="chat.admin_unread > 0"
            class="w-5 h-5 bg-primary text-white text-[8px] font-black rounded-full flex items-center justify-center shadow-lg shadow-primary/20"
          >
            {{ chat.admin_unread }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/Button.vue";
import { timeAgo } from "@/utils/date";

export default {
  name: "DashboardRecentMessages",
  components: { BaseButton },
  props: {
    chats: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: null,
    },
  },
  methods: {
    getChatSenderLetter(chat) {
      if (chat.renter?.username) {
        return chat.renter.username.charAt(0).toUpperCase();
      }
      return "U";
    },
    formatChatTime(date) {
      return timeAgo(date);
    },
  },
};
</script>
